<template>
  <div class="header-desktop__wrapper" :class="headerDynamicClass">
    <div class="header-desktop__gap-filler"></div>
    <div class="header-desktop__container">
      <div class="header-desktop__main">
        <a-lazy-hydrate when-visible>
          <a-header-logo />
        </a-lazy-hydrate>

        <a-lazy-hydrate when-visible>
          <a-global-quicksearch
            class="header-desktop__globalsearch"
            with-close-icon
            hide-label
            single-column
            scrollable
          />
        </a-lazy-hydrate>

        <a-header-actions />
      </div>

      <a-lazy-hydrate when-visible>
        <a-header-navigation
          :navigation-items="navigationItems"
          class="header-desktop__navigation"
        />
      </a-lazy-hydrate>
    </div>
  </div>
</template>

<script>
import AGlobalQuicksearch from 'shared/AGlobalQuicksearch'
import AHeaderNavigation from '@/components/AHeader/AHeaderDesktop/AHeaderNavigation'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import { hydrateWhenIdle } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

export default {
  name: 'AHeaderDesktop',
  mixins: [hydrationHelpers],
  components: {
    AHeaderActions: () => import('@/components/AHeader/Shared/AHeaderActions'),
    AHeaderNavigation,
    AGlobalQuicksearch,
    AHeaderLogo: hydrateWhenIdle(() =>
      import('@/components/AHeader/AHeaderDesktop/AHeaderLogo')
    )
  },
  props: {
    navigationItems: propValidator([PROP_TYPES.ARRAY])
  },
  computed: {
    headerDynamicClass() {
      return {
        mounted: this.isMounted
      }
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style lang="scss" scoped>
.header-desktop__wrapper {
  height: $height-header-expanded;
  padding: 0 60px;
  margin: 0 auto;
  background: $c--header;
  color: white;
  text-align: center;

  @include tablet {
    padding: 0 24px;
  }

  /*
   * IMPORTANT!
   * Modify with caution, since there is JS code that rely on this value.
   * Example: onboarding flow restarts with a delay that considers this value.
   */
  transition: height 0.3s ease;

  .header-desktop__gap-filler {
    @include top-gap-filler($background: $c--black, $z-index: 1);
  }

  .header-desktop__navigation {
    opacity: 0;
    height: 54px;
  }

  &.mounted {
    .header-desktop__navigation {
      opacity: 1;
    }
  }

  .header-desktop__container {
    height: 100%;
    margin: 0 auto;
    max-width: $desktop-full-hd-container;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
  }

  .header-desktop__main {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 42px;
    margin-top: 25px;
    position: relative;
  }

  .header-desktop__globalsearch {
    width: 374px;
    height: 42px;
    z-index: $z-index-header-search;
    margin-right: 12px;

    $margin-left: (
      $above-desktop-xl: 213px,
      $desktop-md: 150px,
      $desktop-sm: 75px,
      $tablet: 26px
    );

    @include setStyleByBreakpoint('margin-left', $margin-left);

    /deep/ .quicksearch-results__wrapper {
      max-height: calc(100vh - 50px);
    }

    /deep/ .a-scrollable-content__content-wrapper {
      max-height: calc(100vh - 50px);
    }
  }

  .header-desktop__navigation {
    width: 100%;
    transition: opacity 0.1s linear;
  }
}
</style>

<style lang="scss">
.global-search-dropdown-open {
  .header-desktop__wrapper .header-desktop__globalsearch {
    width: 480px;
  }
}
</style>
